import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bb5fe718"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row mx-0 shadow-lg bg-white p-3 p-lg-5 rounded-4 mx-auto" }
const _hoisted_2 = { class: "fw-bold text-center fs-5 mb-5" }
const _hoisted_3 = { class: "fw-bold mb-4 fs-6 p-2 text-lg-start text-center" }
const _hoisted_4 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_5 = { class: "w-max-content col-lg-2 col-form-label text-black" }
const _hoisted_6 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_7 = { class: "d-flex col-lg-4 pb-lg-0 pb-3" }
const _hoisted_8 = { class: "w-max-content col-form-label me-4 text-left text-lg-end text-black" }
const _hoisted_9 = { class: "w-100" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_12 = { class: "d-flex col-lg-4" }
const _hoisted_13 = { class: "w-max-content me-4 col-form-label text-left text-lg-end text-black" }
const _hoisted_14 = { class: "w-100" }
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_17 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_18 = { class: "w-max-content col-lg-2 col-form-label text-black" }
const _hoisted_19 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_20 = { class: "d-flex col-lg-4 pb-lg-0 pb-3" }
const _hoisted_21 = { class: "w-max-content me-4 col-form-label text-left text-lg-end text-nowrap text-black" }
const _hoisted_22 = { class: "w-100" }
const _hoisted_23 = ["placeholder"]
const _hoisted_24 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_25 = { class: "d-flex col-lg-4" }
const _hoisted_26 = { class: "w-max-content me-4 col-form-label text-left text-lg-end text-nowrap text-black" }
const _hoisted_27 = { class: "w-100" }
const _hoisted_28 = ["placeholder"]
const _hoisted_29 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_30 = { class: "row border-bottom mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_31 = { class: "w-max-content col-lg-3 text-black" }
const _hoisted_32 = { class: "col-lg-8" }
const _hoisted_33 = { class: "text-black text-break fs-7" }
const _hoisted_34 = { class: "mx-0 px-0 text-black fs-7" }
const _hoisted_35 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_36 = { class: "w-max-content col-lg-2 col-form-label text-black" }
const _hoisted_37 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_38 = { class: "row mx-0 px-0 col-lg-4" }
const _hoisted_39 = { class: "col-lg-7 px-2" }
const _hoisted_40 = { class: "input-group mb-2" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    for: "select-birthday",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_42 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_43 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_44 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_45 = { class: "row mx-0 px-0 col-lg-4" }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_48 = {
  key: 1,
  class: "d-flex"
}
const _hoisted_49 = { class: "col-lg-4 px-2 px-lg-0" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-1 px-lg-0 text-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "hyphen-position" }, " - ")
], -1))
const _hoisted_51 = { class: "col-lg-4 px-2 px-lg-0" }
const _hoisted_52 = {
  for: "zipcode_judgment",
  class: "mt-1 ms-2"
}
const _hoisted_53 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_54 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_55 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_56 = { class: "row mx-0 px-0 col-lg-4 d-block" }
const _hoisted_57 = { class: "mx-0 px-0 col-lg-9 d-flex justify-content-between mb-4" }
const _hoisted_58 = { class: "w-max-content col-form-label text-left px-2 col-lg-4" }
const _hoisted_59 = { class: "mx-lg-0 mx-2 mb-3 mb-lg-0 flex-basic-address" }
const _hoisted_60 = ["disabled"]
const _hoisted_61 = { value: "0" }
const _hoisted_62 = ["value"]
const _hoisted_63 = { class: "mx-0 px-0 col-lg-9 d-flex justify-content-between" }
const _hoisted_64 = { class: "w-max-content col-form-label text-left px-2 col-lg-4" }
const _hoisted_65 = { class: "col-lg-12 px-2" }
const _hoisted_66 = ["placeholder"]
const _hoisted_67 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_68 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_69 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_70 = {
  id: "phone-number",
  class: "row mx-0 px-0 col-lg-4"
}
const _hoisted_71 = { class: "d-flex" }
const _hoisted_72 = { class: "col-lg-3 px-2 px-lg-0" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-1 px-lg-0 text-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "hyphen-position" }, " - ")
], -1))
const _hoisted_74 = { class: "col-lg-3 px-2 px-lg-0" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-1 px-lg-0 text-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "hyphen-position" }, " - ")
], -1))
const _hoisted_76 = { class: "col-lg-3 px-2 px-lg-0" }
const _hoisted_77 = { class: "fw-bold mb-4 fs-6 p-2 text-lg-start text-center" }
const _hoisted_78 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_79 = { class: "w-max-content col-lg-2 col-form-label text-black" }
const _hoisted_80 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_81 = { class: "row mx-0 px-0 col-lg-4" }
const _hoisted_82 = { class: "col-lg-12 px-2" }
const _hoisted_83 = ["placeholder"]
const _hoisted_84 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_85 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_86 = { class: "w-max-content col-lg-2 col-form-label text-black" }
const _hoisted_87 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_88 = { class: "d-flex col-lg-4 pb-lg-0 pb-3" }
const _hoisted_89 = { class: "w-max-content me-4 col-form-label text-left text-lg-end text-black text-nowrap" }
const _hoisted_90 = { class: "w-100" }
const _hoisted_91 = ["value"]
const _hoisted_92 = { class: "d-flex col-lg-4" }
const _hoisted_93 = { class: "w-max-content me-4 col-form-label text-left text-lg-end text-black text-nowrap" }
const _hoisted_94 = { class: "w-100" }
const _hoisted_95 = ["value"]
const _hoisted_96 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_97 = { class: "w-max-content col-lg-2 col-form-label text-black" }
const _hoisted_98 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_99 = { class: "d-flex col-lg-6 px-2" }
const _hoisted_100 = { class: "row mx-0 px-0" }
const _hoisted_101 = { class: "col-lg-10 px-0" }
const _hoisted_102 = { class: "input-group mb-2" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    for: "select-birthday",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "～ 現在", -1))
const _hoisted_105 = { class: "fw-bold mb-4 fs-6 p-2 text-lg-start text-center" }
const _hoisted_106 = { class: "border-bottom pb-4 gx-3 mb-4 d-flex flex-lg-row flex-column" }
const _hoisted_107 = { class: "w-max-content text-black pb-lg-0 pb-3 title-password" }
const _hoisted_108 = { class: "text-black fs-7" }
const _hoisted_109 = { class: "fw-bold fs-6 p-2 text-lg-start text-center" }
const _hoisted_110 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_111 = { class: "w-max-content col-lg-2 col-form-label text-black" }
const _hoisted_112 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_113 = { class: "row mx-0 px-0 col-lg-5 align-items-center" }
const _hoisted_114 = { class: "d-flex col-lg-10 px-2 justify-auth" }
const _hoisted_115 = { class: "form-check me-4" }
const _hoisted_116 = { class: "form-check-label fs-7" }
const _hoisted_117 = ["value"]
const _hoisted_118 = { class: "form-check me-4" }
const _hoisted_119 = { class: "form-check-label fs-7" }
const _hoisted_120 = ["value"]
const _hoisted_121 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_122 = { class: "w-max-content col-lg-3 col-form-label text-black" }
const _hoisted_123 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_124 = { class: "d-flex col-12 px-2 flex-xl-row flex-column" }
const _hoisted_125 = { class: "col-12 col-xl-7 me-4" }
const _hoisted_126 = ["title"]
const _hoisted_127 = ["title"]
const _hoisted_128 = {
  key: 2,
  class: "col-5 col-lg-3 me-4"
}
const _hoisted_129 = ["disabled"]
const _hoisted_130 = {
  key: 1,
  class: "col-form-label fs-7"
}
const _hoisted_131 = {
  id: "sns-linking-title",
  class: "fw-bold fs-6 p-2 text-lg-start text-center"
}
const _hoisted_132 = { class: "mb-4 p-0" }
const _hoisted_133 = { class: "d-flex flex-row align-items-center border-bottom py-4" }
const _hoisted_134 = { class: "d-flex flex-row align-items-center border-bottom py-4" }
const _hoisted_135 = {
  key: 0,
  class: "d-flex flex-row align-items-center border-bottom py-4"
}
const _hoisted_136 = { class: "d-flex justify-content-end mb-3 fs-7" }
const _hoisted_137 = { class: "row mx-0 px-0 d-flex justify-content-center flex-lg-row flex-column-reverse" }
const _hoisted_138 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center" }
const _hoisted_139 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center mb-4 mb-lg-0" }
const _hoisted_140 = {
  class: "modal fade",
  id: "editEmailAlumni",
  tabindex: "-1",
  "aria-labelledby": "editEmailAlumni",
  "aria-hidden": "true"
}
const _hoisted_141 = { class: "py-5 modal-dialog modal-lg" }
const _hoisted_142 = { class: "modal-content" }
const _hoisted_143 = { class: "modal-header" }
const _hoisted_144 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "exampleModalLabel"
}
const _hoisted_145 = { class: "px-lg-5 pt-lg-5 pb-lg-3 p-3" }
const _hoisted_146 = { class: "row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_147 = { class: "w-max-content col-lg-4 col-form-label" }
const _hoisted_148 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_149 = { class: "row mx-0 px-0 col-lg-6" }
const _hoisted_150 = { class: "col-lg-12" }
const _hoisted_151 = ["placeholder"]
const _hoisted_152 = {
  key: 0,
  class: "mt-1 email-same while-spaces"
}
const _hoisted_153 = { class: "row mx-0 px-0 pb-4 gx-3" }
const _hoisted_154 = { class: "w-max-content col-lg-4 col-form-label" }
const _hoisted_155 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_156 = { class: "row mx-0 px-0 col-lg-6" }
const _hoisted_157 = { class: "col-lg-12" }
const _hoisted_158 = ["placeholder"]
const _hoisted_159 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_160 = { class: "row mx-0 px-0 d-flex justify-content-center" }
const _hoisted_161 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center mb-4 mb-lg-0" }
const _hoisted_162 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center" }
const _hoisted_163 = {
  class: "modal fade",
  id: "editPasswordAlumni",
  tabindex: "-1",
  "aria-labelledby": "editPasswordAlumni",
  "aria-hidden": "true"
}
const _hoisted_164 = { class: "py-5 modal-dialog modal-lg" }
const _hoisted_165 = { class: "modal-content" }
const _hoisted_166 = { class: "modal-header" }
const _hoisted_167 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "exampleModalLabel"
}
const _hoisted_168 = { class: "modal-body" }
const _hoisted_169 = { class: "text-center my-3" }
const _hoisted_170 = { class: "ms-2 my-4" }
const _hoisted_171 = { class: "row mx-0 px-0 pb-4 gx-3" }
const _hoisted_172 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_173 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_174 = { class: "row mx-0 px-0 col-lg-7" }
const _hoisted_175 = { class: "col-lg-10" }
const _hoisted_176 = ["placeholder"]
const _hoisted_177 = { class: "mt-2" }
const _hoisted_178 = { class: "row mx-0 px-0 pb-4 gx-3" }
const _hoisted_179 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_180 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_181 = { class: "row mx-0 px-0 col-lg-7" }
const _hoisted_182 = { class: "col-lg-10" }
const _hoisted_183 = ["placeholder"]
const _hoisted_184 = { class: "mt-2" }
const _hoisted_185 = { class: "row mx-0 px-0 pb-4 gx-3" }
const _hoisted_186 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_187 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_188 = { class: "row mx-0 px-0 col-lg-7" }
const _hoisted_189 = { class: "col-lg-10" }
const _hoisted_190 = ["placeholder"]
const _hoisted_191 = { class: "mt-2" }
const _hoisted_192 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_193 = { class: "row mx-0 px-0 d-flex justify-content-center" }
const _hoisted_194 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center mb-4 mb-lg-0" }
const _hoisted_195 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center" }

import { ref, computed, watchEffect, onMounted, watch, nextTick } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import useVuelidate from '@vuelidate/core'
import { required, maxLength, minLength, email, sameAs, requiredIf, numeric } from '@vuelidate/validators'
import { customMaxLength, scrollToErrors, openSnsConnectUrl } from '@/utils'
import dayjs from 'dayjs'
import { omit } from 'lodash'
import flatPickr from 'vue-flatpickr-component'
import { Modal } from 'bootstrap'

import Status from '@/components/status/index.vue'
import Button from '@/components/button/index.vue'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import ErrorMessage from '@/components/error-message/index.vue'
import ModalConfirmUpdate from './edit-confirm/index.vue'
import EditEmailConfirm from './edit-email/components/Confirm.vue'
import EditComplete from './edit-email/components/Complete.vue'
import ErrorToast from '@/components/toast-error/indexErrorToast.vue'

import EditCompletePassword from './edit-password/components/Complete.vue'
import { getMessage } from '@/constants/messageCode'
import { translate } from '@/languages/i18n'
import { configYM, getBirthdayConfig } from '@/constants/datepicker'

// 2022/09/20 PhucNV Check current password invalid UAT#4416: SD40(Ph2-R20220922)
import { REGISTER_STORE, USER_STORE } from '@/store/constants'
import { PASSWORD_FORMAT_REGEX, PASSWORD_REGEX, REGEX_EMOJI, SPECIAL_WORDS } from '@/constants/regex'
import { DEFAULT_MAX_JP_TEXT, DEFAULT_MIN_LENGTH, MAX_LENGTH_EMAIL, MAX_WORD, MIN_LENGTH_EMAIL } from '@/constants/number'
import alumnusServices from '@/services/alumnus-profile.services'
import { debounce } from 'lodash'
import commonService from '@/services/common.service'
import { apiUrlSubpath, PATH, PREFECTURES } from '@/constants/index'
import GoogleLoginButton from '@/components/sns-login-button/GoogleLoginButton.vue'
import ToggleSwitch from '@/components/toggle-switch/index.vue'
import FacebookLoginButton from '@/components/sns-login-button/FacebookLoginButton.vue'
import LineLoginButton from '@/components/sns-login-button/LineLoginButton.vue'
import SnsUnlinkConfirm from '@/views/user/alumni/alumni-profile/sns/components/SnsUnlinkConfirm.vue'
import SnsUnlinkComplete from '@/views/user/alumni/alumni-profile/sns/components/SnsUnlinkComplete.vue'
import { SNS_METHOD, SNS_SITE, snsConnectDefinedErrorMsg } from '@/constants/common'
import { useToast } from 'vue-toastification'
import Loading from '@/components/loading/index.vue'
import { onUnmounted } from 'vue-demi'
import { AuthenMethodTypes } from '@/store/modules/register-alumnus'
import { useCountdown } from '@/use/useCountdown'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const store = useStore()
const toast = useToast()

const listJobs = computed(() => store.getters[REGISTER_STORE.GETTERS.LIST_JOBS])
const editNormalData = computed(() => store.getters[USER_STORE.GETTERS.ALUMNI_PROFILE])
const indexJob = ref()
const subJob = ref([])
const errorUpdate = ref<boolean>(false)
const jobNameParent = ref('')
const jobNameChild = ref('')
const emailSame = ref<string>('')

const jobTypeParentDefaute = ref('')
const jobTypeChildDefaute = ref('')

const snsGenerateLinkLoading = ref<boolean>(false)
const snsUnlinkConfirmDialog = ref()
const snsUnlinkCompleteDialog = ref()
const placeholderDefault = translate('placeholder')
const fullPhoneNumber = computed(() => {
  const p1 = editNormalData.value.phone_number_1 || '000'
  const p2 = editNormalData.value.phone_number_2 || '0000'
  const p3 = editNormalData.value.phone_number_3 || '0000'
  return `${p1}-${p2}-${p3}`
})
const { timeLeft, showCountTime, startCountdown } = useCountdown(`countdownEndTimeSendTest_${route.meta.screenId}`)
const submittingButton = ref<boolean>(false)

onMounted(() => {
  // if (!localStorage.getItem('checkConfirm') || localStorage.getItem('checkConfirm') === 'false') {
  // }
  store.dispatch(USER_STORE.ACTIONS.SET_ALUMNI_PROFILE).then(() => {
    checkAndHandleConnectResult()
  })
  if (localStorage?.getItem('serverError') === 'true') {
    errorUpdate.value = true
  }
  store.dispatch(REGISTER_STORE.ACTIONS.SET_LIST_JOBS)
})

/**
 * Check result of sns connect process by the combination of session store
 * and returned url.
 * in case of connect without error, check with session store to detect the different
 * from last connect, if any different detected -> CONNECT SUCCESS -> scroll to connect view
 */
const checkAndHandleConnectResult = () => {
  const { errorCode } = route.query
  if (errorCode) {
    let messageCode = ''
    if (snsConnectDefinedErrorMsg.includes(errorCode?.toString().toUpperCase() ?? '')) {
      messageCode = errorCode?.toString().toUpperCase()
    } else {
      messageCode = 'ERROR_SOCIAL_ACCOUNT_LINKING'
    }
    toast.error({
      component: ErrorToast,
      props: {
        messageCode: messageCode,
      },
    })
    router.replace({ ...router.currentRoute, query: omit(route.query, ['errorCode']) })
  } else {
    const lastSnsConnectState = sessionStorage.getItem('sns_connect')
    if (lastSnsConnectState) {
      const state = JSON.parse(lastSnsConnectState)
      const updatedField = state.connect ?? ''
      if (editNormalData.value[updatedField] && !state.lastState[updatedField]) {
        document.getElementById('sns-linking-title').scrollIntoView()
      }
      sessionStorage.removeItem('sns_connect')
    }
  }
}

const changeIndexJob = (index: number) => {
  indexJob.value = index
}

const router = useRouter()

const rules = computed(() => {
  return {
    family_name: {
      required,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, DEFAULT_MAX_JP_TEXT),
      pictograms: function (value) {
        if (value) {
          return REGEX_EMOJI.test(value)
        } else {
          return true
        }
      },
    },
    given_name: {
      required,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, DEFAULT_MAX_JP_TEXT),
      pictograms: function (value) {
        if (value) {
          return REGEX_EMOJI.test(value)
        } else {
          return true
        }
      },
    },
    family_name_kana: {
      required,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, DEFAULT_MAX_JP_TEXT),
      fullSizeKatakana: function (value) {
        return /^([ァ-ヶ]|ー)+$/.test(value)
      },
      pictograms: function (value) {
        if (value) {
          return REGEX_EMOJI.test(value)
        } else {
          return true
        }
      },
    },
    given_name_kana: {
      required,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, DEFAULT_MAX_JP_TEXT),
      fullSizeKatakana: function (value) {
        return /^([ァ-ヶ]|ー)+$/.test(value)
      },
      pictograms: function (value) {
        if (value) {
          return REGEX_EMOJI.test(value)
        } else {
          return true
        }
      },
    },
    birthday: {
      required,
      maxDate: function (value) {
        const date = dayjs(value).format('YYYY-MM-DD')
        if (!dayjs().isBefore(dayjs(date))) return true
      },
      minDate: function (value) {
        const date = dayjs('1900/01/01').format('YYYY-MM-DD')
        if (!dayjs(value).isBefore(dayjs(date))) return true
      },
    },
    zipcode_1: {
      required: requiredIf(!formData.value.zipcode_judgment),
      numeric,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: maxLength(3),
    },
    zipcode_2: {
      required: requiredIf(!formData.value.zipcode_judgment),
      numeric,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: maxLength(4),
    },
    zipcode_foreign: {
      required: requiredIf(formData.value.zipcode_judgment),
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, 30),
    },
    address_1: {
      requiredSelect: function (value) {
        if (value && value != 0) return true
      },
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: maxLength(2),
    },
    address_2: {
      required,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: maxLength(1000),
      emoji: function (value) {
        return REGEX_EMOJI.test(value)
      },
    },
    phone_number_1: {
      required,
      numeric,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: maxLength(5),
    },
    phone_number_2: {
      required,
      numeric,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: maxLength(4),
    },
    phone_number_3: {
      required,
      numeric,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: maxLength(4),
    },
    job_type_parent_id: {
      required,
    },
    job_type_child_id: {
      required,
    },

    institution: {
      required,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, MAX_WORD),
      pictograms: function (value) {
        if (value) {
          return REGEX_EMOJI.test(value)
        } else {
          return true
        }
      },
    },
    enrollment_start_period: {
      required,
      maxDate: function (value) {
        const date = dayjs(value).format('YYYY-MM-DD')
        if (!dayjs().isBefore(dayjs(date))) return true
      },
      minDate: function (value) {
        const date = dayjs('1900/01/01').format('YYYY-MM-DD')
        if (!dayjs(value).isBefore(dayjs(date))) return true
      },
    },
    authentication_method: {
      required,
    },
  }
})
const countDefault = ref(1)
const formData = ref(editNormalData.value)
const listPrefectures = ref(PREFECTURES.slice(0, -1))
const lastChoosenPrefecture = ref(0)

watchEffect(() => {
  formData.value = editNormalData.value
  if (formData.value.zipcode_1 === null) {
    formData.value.zipcode_1 = ''
  }
  if (formData.value.zipcode_2 === null) {
    formData.value.zipcode_2 = ''
  }
  if (formData.value.zipcode_foreign === null) {
    formData.value.zipcode_foreign = ''
  }
  if (formData.value.zipcode_judgment === null) {
    formData.value.zipcode_judgment = ''
  }
  if (countDefault.value <= 2) {
    countDefault.value += 1
    jobTypeParentDefaute.value = editNormalData.value?.job_type_parent_id
    jobTypeChildDefaute.value = editNormalData.value?.job_type_child_id
  }
})

const v$ = useVuelidate(rules, formData)

watchEffect(() => {
  if (formData.value.zipcode_judgment) {
    listPrefectures.value = PREFECTURES.slice(-1)
    lastChoosenPrefecture.value = formData.value?.address_1
    formData.value.address_1 = 48
  } else {
    listPrefectures.value = PREFECTURES.slice(0, -1)
    if (formData.value?.address_1 && formData.value?.address_1 !== 48) {
      lastChoosenPrefecture.value = formData.value?.address_1
    } else {
      formData.value.address_1 = lastChoosenPrefecture.value !== 48 ? lastChoosenPrefecture.value : 0
    }
  }
})

const backToLobby = () => {
  router.push('/alumni/lobby')
}

const handleError = (status: boolean) => {
  errorUpdate.value = status
}

const modalUpdate = ref(null)

const onSubmit = async (): Promise<void> => {
  v$.value.$touch()

  const isCheckedNGItems: Array<{ value: boolean }> = [isCheckedNGFamilyName, isCheckedNGGivenName, isCheckedNGFamilyNameKana, isCheckedNGGivenNameKana, isCheckedNGInstitution]
  isCheckedNGItems.forEach((checkedNGItem) => (checkedNGItem.value = false))
  await Promise.all([checkNGFamilyName(), checkNGGivenName(), checkNGFamilyNameKana(), checkNGGivenNameKana(), checkNGInstitution()])
  while (!isCheckedNGItems.every((checkedNGItem) => checkedNGItem.value)) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }

  if (v$.value.$invalid || ngKeyFamilyName.value || ngKeyGivenName.value || ngKeyFamilyNameKana.value || ngKeyGivenNameKana.value || ngKeyInstitution.value) {
    nextTick(() => {
      scrollToErrors()
    })
    return
  }

  modalUpdate.value.showUpdateModal()

  const itemParent = listJobs.value?.filter((item: any) => item.id === formData.value.job_type_parent_id)
  jobNameParent.value = itemParent[0].name
  jobNameChild.value = itemParent[0]?.child?.filter((item: any) => item.id === formData.value.job_type_child_id)[0].name

  store.dispatch(USER_STORE.ACTIONS.UPDATE_ALUMNI_PROFILE, formData.value)

  // localStorage.setItem('checkConfirm', true)
  localStorage?.removeItem('serverError')
}

// const emailData = computed(() => store.getters[USER_STORE.GETTERS.ALUMNI_PROFILE])

watchEffect(() => {
  localStorage.removeItem('checkSubmit')
})

const modalConfirmEmail = ref()
const modalEmail = ref()

const formDataEmail = ref({
  email: '',
  emailConfirm: '',
})

const emailRules = computed(() => {
  return {
    email: {
      required,
      minLength: minLength(MIN_LENGTH_EMAIL),
      maxLength: (value: string) => customMaxLength(value, MAX_LENGTH_EMAIL),
      email,
      pictograms: function (value) {
        if (value) {
          return REGEX_EMOJI.test(value)
        } else {
          return true
        }
      },
    },
    emailConfirm: {
      required,
      minLength: minLength(MIN_LENGTH_EMAIL),
      maxLength: (value: string) => customMaxLength(value, MAX_LENGTH_EMAIL),
      email,
      sameAsEmail: sameAs(formDataEmail.value.email),
    },
  }
})

const email_v$ = ref(useVuelidate(emailRules, formDataEmail))

// 2022/09/13 TienNV Fix double click confirm email
const loadingConfirmMail = ref(false)

const submitConfirmEmail = async (): Promise<void> => {
  loadingConfirmMail.value = true
  email_v$.value.$touch()
  if (email_v$.value.$invalid) {
    // 2022/09/29 PhucNV Fixbug button confirm keeps showing circle marks UAT#4484: SD40
    loadingConfirmMail.value = false
    nextTick(() => {
      scrollToErrors('.invalid-feedback', '#editEmailAlumni')
    })
    return
  }

  try {
    const response = await alumnusServices.checkEmailDuplicate({ email: formDataEmail.value.email })
    if (response?.status === 200) {
      modalEmail.value?.hide()
      modalConfirmEmail.value?.show()
    } else {
      emailSame.value = response?.response?.data?.data[0]?.message_code
    }
    // 2022/09/29 PhucNV Fixbug button confirm keeps showing circle marks UAT#4484: SD40
    loadingConfirmMail.value = false
  } catch (error) {
    loadingConfirmMail.value = false
    console.log(error)
  }

  // store.dispatch(USER_STORE.ACTIONS.SET_ALUMNI_PROFILE, formDataEmail.value)
}
const resetFormEmail = (): void => {
  email_v$.value.$reset()
  emailSame.value = ''
  Object.assign(formDataEmail.value, {
    email: '',
    emailConfirm: '',
  })
}

const formDataPassword = ref({
  password: '',
  password_confirmation: '',
})

const serverError = ref<boolean>(false)
const modalComplete = ref()
const modalEditPassword = ref()

// const { withAsync } = helpers
// const ngWord = withAsync(async () => {
//   try {
//     const data = await commonService.sendNGWordCheck({ sentence: password_v$.value.password.$model })
//     return !data.data?.data?.has_ngword
//   } catch (e) {
//     return false
//   }
// })

const passwordRules = computed(() => {
  return {
    password: {
      required,
      maxLength: maxLength(128),
      minLength: minLength(8),
      //ngWord,
      containsSpecialWords: function (value) {
        let count = 0
        SPECIAL_WORDS.forEach((e) => {
          if (value === e) count++
        })

        if (count === 0) return true
      },
      emoji: function (value) {
        return REGEX_EMOJI.test(value)
      },
      containsTypeSpecialCharacter: function (value) {
        // let count = 0
        let count = 0
        ;[...value].forEach((e) => {
          if (PASSWORD_FORMAT_REGEX.test(e)) count++
        })
        if (count === value.length) return true
      },
      containsType: function (value) {
        return PASSWORD_REGEX.test(value)
      },
    },
    password_confirmation: {
      required,
      maxLength: maxLength(128),
      minLength: minLength(8),
      sameAsPassword: sameAs(formDataPassword.value.password),
    },
    // 2022/09/20 PhucNV Check current password invalid UAT#4416: SD40(Ph2-R20220922)
    current_password: {
      required,
      maxLength: maxLength(128),
      minLength: minLength(8),
      containsSpecialWords: function (value) {
        let count = 0
        SPECIAL_WORDS.forEach((e) => {
          if (value === e) count++
        })

        if (count === 0) return true
      },
      emoji: function (value) {
        return REGEX_EMOJI.test(value)
      },
      containsTypeSpecialCharacter: function (value) {
        let count = 0
        ;[...value].forEach((e) => {
          if (PASSWORD_FORMAT_REGEX.test(e)) count++
        })
        if (count === value.length) return true
      },
      containsType: function (value) {
        return PASSWORD_REGEX.test(value)
      },
    },
  }
})

const password_v$ = useVuelidate(passwordRules, formDataPassword)

const validateNotChange = ref<boolean>(false)

// 2022/09/20 PhucNV Check current password invalid UAT#4416: SD40(Ph2-R20220922)
const validateCurrentPassword = ref<boolean>(false)
const serverErrorCode = ref<string>('')

// 2022/09/14 TienNV Fix double click confirm password
const loadingConfirmPassword = ref(false)

const submitPasswordConfirm = async (): Promise<void> => {
  loadingConfirmPassword.value = true
  password_v$.value.$touch()
  if (password_v$.value.$invalid) {
    loadingConfirmPassword.value = false
    nextTick(() => {
      scrollToErrors('.invalid-feedback', '#editPasswordAlumni')
    })
    return
  }

  try {
    const response = await alumnusServices.alumnusResetPassword({ ...formDataPassword.value })

    if (response.status === 200) {
      serverError.value = false
      validateNotChange.value = false
      modalEditPassword.value?.hide()
      modalComplete.value?.show()
      // 2022/09/14 TienNV Fix double click confirm password
      setTimeout(() => {
        loadingConfirmPassword.value = false
      }, 2000)
      return
    } else {
      // 2022/09/20 PhucNV Check current password invalid UAT#4416: SD40(Ph2-R20220922)
      let messageCode = response?.response?.data?.data[0]?.message_code
      serverErrorCode.value = messageCode
      loadingConfirmPassword.value = false

      if (messageCode === 'VALIDATE_NOT_CHANGED') {
        validateNotChange.value = true
        return
      } else if (messageCode === 'VALIDATE_CURRENT_PASSWORD') {
        validateCurrentPassword.value = true
        return
      }
      serverError.value = true
    }
  } catch (error: any) {
    serverError.value = true
    loadingConfirmPassword.value = false
    console.log('error', error)
  }
}

const resetFormPassword = (): void => {
  password_v$.value.$reset()
  serverError.value = false
  emailSame.value = ''
  validateNotChange.value = false

  // 2022/09/20 PhucNV Check current password invalid UAT#4416: SD40(Ph2-R20220922)
  validateCurrentPassword.value = false
  Object.assign(formDataPassword.value, {
    password: '',
    password_confirmation: '',
    current_password: '',
  })
}

onMounted(() => {
  modalConfirmEmail.value = new Modal(document.getElementById('confirmEditEmailAlumni'))
  modalEmail.value = new Modal(document.getElementById('editEmailAlumni'))
  window.addEventListener('unload', closeLoadingDialog)
})

onUnmounted(() => {
  // Avoid memory leak
  window.removeEventListener('unload', closeLoadingDialog)
})
const closeLoadingDialog = () => {
  snsGenerateLinkLoading.value = false
}
watchEffect(() => {
  if (listJobs.value.length > 0) {
    subJob.value = listJobs.value.find((e: any) => e.id === formData.value?.job_type_parent_id)?.child
  }
})

watch(
  () => indexJob.value,
  () => {
    if (indexJob.value === jobTypeParentDefaute.value) {
      formData.value.job_type_child_id = jobTypeChildDefaute.value
      return
    }
    if (subJob.value.length > 0) {
      formData.value.job_type_child_id = subJob.value[0].id
    }
  }
)
const changeEmail = () => {
  emailSame.value = ''
}

const isCheckedNGFamilyName = { value: false }
const ngKeyFamilyName = ref<boolean>(false)
const checkNGFamilyName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.family_name.$model })
  ngKeyFamilyName.value = data.data?.data?.has_ngword
  isCheckedNGFamilyName.value = true
}, 200)

const isCheckedNGGivenName = { value: false }
const ngKeyGivenName = ref<boolean>(false)
const checkNGGivenName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.given_name.$model })
  ngKeyGivenName.value = data.data?.data?.has_ngword
  isCheckedNGGivenName.value = true
}, 200)

const isCheckedNGFamilyNameKana = { value: false }
const ngKeyFamilyNameKana = ref<boolean>(false)
const checkNGFamilyNameKana = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.family_name_kana.$model })
  ngKeyFamilyNameKana.value = data.data?.data?.has_ngword
  isCheckedNGFamilyNameKana.value = true
}, 200)

const isCheckedNGGivenNameKana = { value: false }
const ngKeyGivenNameKana = ref<boolean>(false)
const checkNGGivenNameKana = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.given_name_kana.$model })
  ngKeyGivenNameKana.value = data.data?.data?.has_ngword
  isCheckedNGGivenNameKana.value = true
}, 200)

const isCheckedNGInstitution = { value: false }
const ngKeyInstitution = ref<boolean>(false)
const checkNGInstitution = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.institution.$model })
  ngKeyInstitution.value = data.data?.data?.has_ngword
  isCheckedNGInstitution.value = true
}, 200)

const onSnsLinkingSwitchStateChange = (sns: SNS_SITE) => (data) => {
  const connectedStatusField = {
    [SNS_SITE.SNS_FACEBOOK]: 'facebook_connected',
    [SNS_SITE.SNS_GOOGLE]: 'google_connected',
    [SNS_SITE.SNS_LINE]: 'line_connected',
  }[sns]
  const status = editNormalData.value[connectedStatusField]
  if (status) {
    snsUnlinkConfirmDialog.value.showConfirmModal(sns)
  } else {
    snsGenerateLinkLoading.value = true
    const { google_connected, facebook_connected, line_connected } = editNormalData.value
    const snsConnectState = {
      lastState: {
        google_connected,
        facebook_connected,
        line_connected,
      },
      connect: connectedStatusField,
    }
    sessionStorage.setItem('sns_connect', JSON.stringify(snsConnectState))
    openSnsConnectUrl(sns, SNS_METHOD.CONNECT, { userId: editNormalData.value.id })
  }
}

const onUnlinkConfirm = (sns: string) => async () => {
  const unlinkResponse = await alumnusServices.unlinkSnsConnect(sns)
  const { success = false } = unlinkResponse?.data
  if (success) {
    snsUnlinkCompleteDialog.value.showCompleteModal(sns)
  }
  store.dispatch(USER_STORE.ACTIONS.SET_ALUMNI_PROFILE)
}

const sendTestPhoneNumber = debounce(async () => {
  submittingButton.value = true
  const p1 = editNormalData.value.phone_number_1 || '000'
  const p2 = editNormalData.value.phone_number_2 || '0000'
  const p3 = editNormalData.value.phone_number_3 || '0000'
  const phoneNumber = `${p1}${p2}${p3}`
  try {
    const data = await commonService.sendTestPhoneNumber({ phone_number: phoneNumber })
    if (data?.response?.status === 400) {
      scrollToErrors('#phone-number')
      toast.error({
        component: ErrorToast,
        props: {
          messageCode: 'バリデーションエラー',
        },
      })
      submittingButton.value = false
    } else if (data?.status !== 200) {
      toast.error({
        component: ErrorToast,
        props: {
          messageCode: 'リクエストエラーが発生しました。しばらく経ってからアクセスしてください。',
        },
      })
      submittingButton.value = false
    } else {
      startCountdown(30)
    }
  } catch (error) {
    toast.error({
      component: ErrorToast,
      props: {
        messageCode: 'リクエストエラーが発生しました。しばらく経ってからアクセスしてください。',
      },
    })
    submittingButton.value = false
  }
}, 200)
watch(showCountTime, (newVal) => {
  submittingButton.value = newVal
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", {
      class: "container pt-5 pb-3 pb-lg-5 px-2",
      onSubmit: _cache[27] || (_cache[27] = _withModifiers(() => {}, ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(translate)('account')), 1),
        (errorUpdate.value)
          ? (_openBlock(), _createBlock(ErrorMessage, {
              key: 0,
              title: _unref(translate)('SD40serverErrorMessage')
            }, null, 8, ["title"]))
          : _createCommentVNode("", true),
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_unref(translate)('basicInformation')), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", _hoisted_5, _toDisplayString(_unref(translate)('nameKanji')), 1),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(Status)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString(_unref(translate)('surName')), 1),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "family_name",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).family_name.$model) = $event)),
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(checkNGFamilyName) && _unref(checkNGFamilyName)(...args))),
                class: _normalizeClass(['form-control', ngKeyFamilyName.value || _unref(v$).family_name.$error ? 'is-invalid' : '']),
                placeholder: _unref(translate)('placeholder')
              }, null, 42, _hoisted_10), [
                [
                  _vModelText,
                  _unref(v$).family_name.$model,
                  void 0,
                  { trim: true }
                ]
              ]),
              (ngKeyFamilyName.value && !_unref(v$).family_name.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                : _createCommentVNode("", true),
              _createVNode(InputErrorMessage, {
                title: 'surName',
                params: [1, 20],
                validator: _unref(v$).family_name.$errors[0]?.$validator
              }, null, 8, ["validator"])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(translate)('name')), 1),
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "given_name",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).given_name.$model) = $event)),
                onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(checkNGGivenName) && _unref(checkNGGivenName)(...args))),
                class: _normalizeClass(['form-control', ngKeyGivenName.value || _unref(v$).given_name.$error ? 'is-invalid' : '']),
                placeholder: _unref(translate)('placeholder')
              }, null, 42, _hoisted_15), [
                [
                  _vModelText,
                  _unref(v$).given_name.$model,
                  void 0,
                  { trim: true }
                ]
              ]),
              (ngKeyGivenName.value && !_unref(v$).given_name.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                : _createCommentVNode("", true),
              _createVNode(InputErrorMessage, {
                title: _unref(translate)('name'),
                params: [1, 20],
                validator: _unref(v$).given_name.$errors[0]?.$validator
              }, null, 8, ["title", "validator"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("label", _hoisted_18, _toDisplayString(_unref(translate)('nameKatakana')), 1),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(Status)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("label", _hoisted_21, _toDisplayString(_unref(translate)('surNameKatakana')), 1),
            _createElementVNode("div", _hoisted_22, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "family_name_kana",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).family_name_kana.$model) = $event)),
                onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(checkNGFamilyNameKana) && _unref(checkNGFamilyNameKana)(...args))),
                class: _normalizeClass(['form-control', ngKeyFamilyNameKana.value || _unref(v$).family_name_kana.$error ? 'is-invalid' : '']),
                placeholder: _unref(translate)('placeholder')
              }, null, 42, _hoisted_23), [
                [
                  _vModelText,
                  _unref(v$).family_name_kana.$model,
                  void 0,
                  { trim: true }
                ]
              ]),
              (ngKeyFamilyNameKana.value && !_unref(v$).family_name_kana.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                : _createCommentVNode("", true),
              _createVNode(InputErrorMessage, {
                title: _unref(translate)('surNameKatakana'),
                params: [1, 20],
                validator: _unref(v$).family_name_kana.$errors[0]?.$validator
              }, null, 8, ["title", "validator"])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("label", _hoisted_26, _toDisplayString(_unref(translate)('lastNameKatakana')), 1),
            _createElementVNode("div", _hoisted_27, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "given_name_kana",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(v$).given_name_kana.$model) = $event)),
                onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_unref(checkNGGivenNameKana) && _unref(checkNGGivenNameKana)(...args))),
                class: _normalizeClass(['form-control', ngKeyGivenNameKana.value || _unref(v$).given_name_kana.$error ? 'is-invalid' : '']),
                placeholder: _unref(translate)('placeholder')
              }, null, 42, _hoisted_28), [
                [
                  _vModelText,
                  _unref(v$).given_name_kana.$model,
                  void 0,
                  { trim: true }
                ]
              ]),
              (ngKeyGivenNameKana.value && !_unref(v$).given_name_kana.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                : _createCommentVNode("", true),
              _createVNode(InputErrorMessage, {
                title: _unref(translate)('lastNameKatakana'),
                params: [1, 20],
                validator: _unref(v$).given_name_kana.$errors[0]?.$validator
              }, null, 8, ["title", "validator"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("label", _hoisted_31, _toDisplayString(_unref(translate)('email')), 1),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, _toDisplayString(_unref(editNormalData).email), 1),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("span", null, _toDisplayString(_unref(translate)('SD40pleaseEmail')), 1),
              _createElementVNode("span", {
                class: "hover-link text-decoration-underline cursor-pointer",
                "data-bs-toggle": "modal",
                "data-bs-target": "#editEmailAlumni",
                onClick: resetFormEmail
              }, _toDisplayString(_unref(translate)('SD40reset')), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("label", _hoisted_36, _toDisplayString(_unref(translate)('dateOfBirth')), 1),
          _createElementVNode("div", _hoisted_37, [
            _createVNode(Status)
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createVNode(_unref(flatPickr), {
                  name: "birthday",
                  modelValue: _unref(v$).birthday.$model,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(v$).birthday.$model) = $event)),
                  config: _unref(getBirthdayConfig)(_unref(v$).birthday.$model),
                  class: _normalizeClass(['form-control bg-white', _unref(v$).birthday.$error ? 'is-invalid' : ''])
                }, null, 8, ["modelValue", "config", "class"]),
                _hoisted_41
              ]),
              _createVNode(InputErrorMessage, {
                title: _unref(translate)('dateOfBirth'),
                params: [1900, 1, 1],
                validator: _unref(v$).birthday.$errors[0]?.$validator
              }, null, 8, ["title", "validator"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("label", _hoisted_43, _toDisplayString(_unref(translate)('zipcode')), 1),
          _createElementVNode("div", _hoisted_44, [
            _createVNode(Status)
          ]),
          _createElementVNode("div", _hoisted_45, [
            (formData.value.zipcode_judgment)
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _withDirectives(_createElementVNode("input", {
                      type: "tel",
                      class: _normalizeClass(['form-control', _unref(v$).zipcode_foreign.$error ? 'is-invalid' : '']),
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(v$).zipcode_foreign.$model) = $event))
                    }, null, 2), [
                      [
                        _vModelText,
                        _unref(v$).zipcode_foreign.$model,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createVNode(InputErrorMessage, {
                      title: _unref(translate)('address'),
                      params: [_unref(DEFAULT_MIN_LENGTH), 30],
                      validator: _unref(v$).zipcode_foreign.$errors[0]?.$validator
                    }, null, 8, ["title", "params", "validator"])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _withDirectives(_createElementVNode("input", {
                      type: "tel",
                      class: _normalizeClass(['form-control', _unref(v$).zipcode_1.$error ? 'is-invalid' : '']),
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(v$).zipcode_1.$model) = $event))
                    }, null, 2), [
                      [
                        _vModelText,
                        _unref(v$).zipcode_1.$model,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createVNode(InputErrorMessage, {
                      title: _unref(translate)('zipcode1'),
                      params: [_unref(DEFAULT_MIN_LENGTH), 3],
                      validator: _unref(v$).zipcode_1.$errors[0]?.$validator
                    }, null, 8, ["title", "params", "validator"])
                  ]),
                  _hoisted_50,
                  _createElementVNode("div", _hoisted_51, [
                    _withDirectives(_createElementVNode("input", {
                      type: "tel",
                      class: _normalizeClass(['form-control', _unref(v$).zipcode_2.$error ? 'is-invalid' : '']),
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(v$).zipcode_2.$model) = $event))
                    }, null, 2), [
                      [
                        _vModelText,
                        _unref(v$).zipcode_2.$model,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createVNode(InputErrorMessage, {
                      title: _unref(translate)('zipcode2'),
                      params: [_unref(DEFAULT_MIN_LENGTH), 4],
                      validator: _unref(v$).zipcode_2.$errors[0]?.$validator
                    }, null, 8, ["title", "params", "validator"])
                  ])
                ])),
            _createElementVNode("label", _hoisted_52, [
              _withDirectives(_createElementVNode("input", {
                id: "zipcode_judgment",
                type: "checkbox",
                class: "mr-1 cursor-pointer form-check-input",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.zipcode_judgment) = $event))
              }, null, 512), [
                [_vModelCheckbox, formData.value.zipcode_judgment]
              ]),
              _createTextVNode(" " + _toDisplayString(_unref(translate)('outsideJapan')), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("label", _hoisted_54, _toDisplayString(_unref(translate)('address')), 1),
          _createElementVNode("div", _hoisted_55, [
            _createVNode(Status)
          ]),
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("label", _hoisted_58, _toDisplayString(_unref(translate)('address1')), 1),
              _createElementVNode("div", _hoisted_59, [
                _withDirectives(_createElementVNode("select", {
                  class: _normalizeClass(["form-select", ['form-control', _unref(v$).address_1.$error ? 'is-invalid' : '']]),
                  "aria-label": "Default select example",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(v$).address_1.$model) = $event)),
                  disabled: formData.value.zipcode_judgment
                }, [
                  _createElementVNode("option", _hoisted_61, _toDisplayString(_unref(translate)('placeholderSelect')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listPrefectures.value, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: item.id,
                      key: item.id
                    }, _toDisplayString(item.name), 9, _hoisted_62))
                  }), 128))
                ], 10, _hoisted_60), [
                  [_vModelSelect, _unref(v$).address_1.$model]
                ]),
                _createVNode(InputErrorMessage, {
                  title: _unref(translate)('address1'),
                  validator: _unref(v$).address_1.$errors[0]?.$validator
                }, null, 8, ["title", "validator"])
              ])
            ]),
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("label", _hoisted_64, _toDisplayString(_unref(translate)('address2')), 1),
              _createElementVNode("div", _hoisted_65, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: _normalizeClass(['form-control', _unref(v$).address_2.$error ? 'is-invalid' : '']),
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(v$).address_2.$model) = $event)),
                  placeholder: _unref(placeholderDefault)
                }, null, 10, _hoisted_66), [
                  [
                    _vModelText,
                    _unref(v$).address_2.$model,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _createVNode(InputErrorMessage, {
                  title: _unref(translate)('address2'),
                  params: [_unref(DEFAULT_MIN_LENGTH), 1000],
                  validator: _unref(v$).address_2.$errors[0]?.$validator
                }, null, 8, ["title", "params", "validator"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_67, [
          _createElementVNode("label", _hoisted_68, _toDisplayString(_unref(translate)('PhoneNumber')), 1),
          _createElementVNode("div", _hoisted_69, [
            _createVNode(Status)
          ]),
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("div", _hoisted_72, [
                _withDirectives(_createElementVNode("input", {
                  type: "tel",
                  class: _normalizeClass(['form-control', _unref(v$).phone_number_1.$error ? 'is-invalid' : '']),
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(v$).phone_number_1.$model) = $event))
                }, null, 2), [
                  [
                    _vModelText,
                    _unref(v$).phone_number_1.$model,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _createVNode(InputErrorMessage, {
                  title: _unref(translate)('PhoneNumber1'),
                  params: [_unref(DEFAULT_MIN_LENGTH), 5],
                  validator: _unref(v$).phone_number_1.$errors[0]?.$validator
                }, null, 8, ["title", "params", "validator"])
              ]),
              _hoisted_73,
              _createElementVNode("div", _hoisted_74, [
                _withDirectives(_createElementVNode("input", {
                  type: "tel",
                  class: _normalizeClass(['form-control', _unref(v$).phone_number_2.$error ? 'is-invalid' : '']),
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(v$).phone_number_2.$model) = $event))
                }, null, 2), [
                  [
                    _vModelText,
                    _unref(v$).phone_number_2.$model,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _createVNode(InputErrorMessage, {
                  title: _unref(translate)('PhoneNumber2'),
                  params: [_unref(DEFAULT_MIN_LENGTH), 4],
                  validator: _unref(v$).phone_number_2.$errors[0]?.$validator
                }, null, 8, ["title", "params", "validator"])
              ]),
              _hoisted_75,
              _createElementVNode("div", _hoisted_76, [
                _withDirectives(_createElementVNode("input", {
                  type: "tel",
                  class: _normalizeClass(['form-control', _unref(v$).phone_number_3.$error ? 'is-invalid' : '']),
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(v$).phone_number_3.$model) = $event))
                }, null, 2), [
                  [
                    _vModelText,
                    _unref(v$).phone_number_3.$model,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _createVNode(InputErrorMessage, {
                  title: _unref(translate)('PhoneNumber3'),
                  params: [_unref(DEFAULT_MIN_LENGTH), 4],
                  validator: _unref(v$).phone_number_3.$errors[0]?.$validator
                }, null, 8, ["title", "params", "validator"])
              ])
            ])
          ])
        ]),
        _createElementVNode("h3", _hoisted_77, _toDisplayString(_unref(translate)('SD40currentJob2')), 1),
        _createElementVNode("div", _hoisted_78, [
          _createElementVNode("label", _hoisted_79, _toDisplayString(_unref(translate)('affiliation')), 1),
          _createElementVNode("div", _hoisted_80, [
            _createVNode(Status)
          ]),
          _createElementVNode("div", _hoisted_81, [
            _createElementVNode("div", _hoisted_82, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "institution",
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(v$).institution.$model) = $event)),
                class: _normalizeClass(['form-control', ngKeyInstitution.value || _unref(v$).institution.$error ? 'is-invalid' : '']),
                placeholder: _unref(translate)(`SA20placeholderName3`),
                onChange: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_unref(checkNGInstitution) && _unref(checkNGInstitution)(...args)))
              }, null, 42, _hoisted_83), [
                [
                  _vModelText,
                  _unref(v$).institution.$model,
                  void 0,
                  { trim: true }
                ]
              ]),
              (ngKeyInstitution.value && !_unref(v$).institution.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_84, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                : _createCommentVNode("", true),
              _createVNode(InputErrorMessage, {
                title: _unref(translate)('affiliation'),
                params: [1, 100],
                validator: _unref(v$).institution.$errors[0]?.$validator
              }, null, 8, ["title", "validator"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_85, [
          _createElementVNode("label", _hoisted_86, _toDisplayString(_unref(translate)('occupation')), 1),
          _createElementVNode("div", _hoisted_87, [
            _createVNode(Status)
          ]),
          _createElementVNode("div", _hoisted_88, [
            _createElementVNode("label", _hoisted_89, _toDisplayString(_unref(translate)('SA20mainJob')), 1),
            _createElementVNode("div", _hoisted_90, [
              _withDirectives(_createElementVNode("select", {
                class: _normalizeClass(["form-select", ['form-control', _unref(v$).job_type_parent_id.$error ? 'is-invalid' : '']]),
                "aria-label": "Default select example",
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(v$).job_type_parent_id.$model) = $event)),
                onChange: _cache[21] || (_cache[21] = ($event: any) => (changeIndexJob(formData.value.job_type_parent_id)))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listJobs), (item) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: item.id,
                    key: item.id
                  }, _toDisplayString(item.name), 9, _hoisted_91))
                }), 128))
              ], 34), [
                [_vModelSelect, _unref(v$).job_type_parent_id.$model]
              ]),
              _createVNode(InputErrorMessage, {
                title: _unref(translate)('SA20mainJob'),
                params: [1, 20],
                validator: _unref(v$).job_type_parent_id.$errors[0]?.$validator
              }, null, 8, ["title", "validator"])
            ])
          ]),
          _createElementVNode("div", _hoisted_92, [
            _createElementVNode("label", _hoisted_93, _toDisplayString(_unref(translate)('SA20subJob')), 1),
            _createElementVNode("div", _hoisted_94, [
              _withDirectives(_createElementVNode("select", {
                class: _normalizeClass(["form-select", ['form-control', _unref(v$).job_type_child_id.$error ? 'is-invalid' : '']]),
                "aria-label": "Default select example",
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(v$).job_type_child_id.$model) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subJob.value, (item) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: item.id,
                    key: item.id
                  }, _toDisplayString(item.name), 9, _hoisted_95))
                }), 128))
              ], 2), [
                [_vModelSelect, _unref(v$).job_type_child_id.$model]
              ]),
              _createVNode(InputErrorMessage, {
                title: _unref(translate)('SA20subJob'),
                params: [1, 20],
                validator: _unref(v$).job_type_child_id.$errors[0]?.$validator
              }, null, 8, ["title", "validator"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_96, [
          _createElementVNode("label", _hoisted_97, _toDisplayString(_unref(translate)('affiliationPeriod')), 1),
          _createElementVNode("div", _hoisted_98, [
            _createVNode(Status)
          ]),
          _createElementVNode("div", _hoisted_99, [
            _createElementVNode("div", _hoisted_100, [
              _createElementVNode("div", _hoisted_101, [
                _createElementVNode("div", _hoisted_102, [
                  _createVNode(_unref(flatPickr), {
                    name: "enrollment_start",
                    modelValue: _unref(v$).enrollment_start_period.$model,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(v$).enrollment_start_period.$model) = $event)),
                    config: _unref(configYM)(_unref(v$).enrollment_start_period.$model),
                    class: _normalizeClass(['form-control bg-white', _unref(v$).enrollment_start_period.$error ? 'is-invalid' : ''])
                  }, null, 8, ["modelValue", "config", "class"]),
                  _hoisted_103
                ]),
                _createVNode(InputErrorMessage, {
                  title: _unref(translate)('affiliationPeriod'),
                  params: [1900, 1, 1],
                  validator: _unref(v$).enrollment_start_period.$errors[0]?.$validator
                }, null, 8, ["title", "validator"])
              ])
            ]),
            _hoisted_104
          ])
        ]),
        _createElementVNode("h3", _hoisted_105, _toDisplayString(_unref(translate)('SA20passwordSecret')), 1),
        _createElementVNode("div", _hoisted_106, [
          _createElementVNode("label", _hoisted_107, _toDisplayString(_unref(translate)('password')), 1),
          _createElementVNode("div", _hoisted_108, [
            _createElementVNode("span", null, _toDisplayString(_unref(translate)('SD40pleasePass')), 1),
            _createElementVNode("span", {
              class: "hover-link text-decoration-underline cursor-pointer",
              "data-bs-toggle": "modal",
              "data-bs-target": "#editPasswordAlumni",
              onClick: resetFormPassword
            }, _toDisplayString(_unref(translate)('SD40reset')), 1)
          ])
        ]),
        _createElementVNode("h3", _hoisted_109, _toDisplayString(_unref(translate)('twoFA')), 1),
        _createElementVNode("div", _hoisted_110, [
          _createElementVNode("label", _hoisted_111, _toDisplayString(_unref(translate)('method')), 1),
          _createElementVNode("div", _hoisted_112, [
            _createVNode(Status)
          ]),
          _createElementVNode("div", _hoisted_113, [
            _createElementVNode("div", _hoisted_114, [
              _createElementVNode("div", _hoisted_115, [
                _createElementVNode("label", _hoisted_116, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "authentication_method",
                    value: _unref(AuthenMethodTypes).SMS,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(v$).authentication_method.$model) = $event))
                  }, null, 8, _hoisted_117), [
                    [_vModelRadio, _unref(v$).authentication_method.$model]
                  ]),
                  _createTextVNode(" " + _toDisplayString(_unref(translate)('useSMS')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_118, [
                _createElementVNode("label", _hoisted_119, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "authentication_method",
                    value: _unref(AuthenMethodTypes).EMAIL,
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(v$).authentication_method.$model) = $event))
                  }, null, 8, _hoisted_120), [
                    [_vModelRadio, _unref(v$).authentication_method.$model]
                  ]),
                  _createTextVNode(" " + _toDisplayString(_unref(translate)('useEmail')), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_121, [
          _createElementVNode("label", _hoisted_122, _toDisplayString(_unref(v$).authentication_method.$model !== _unref(AuthenMethodTypes).EMAIL ? _unref(translate)('phone') : _unref(translate)('email')), 1),
          _createElementVNode("div", _hoisted_123, [
            _createElementVNode("div", _hoisted_124, [
              _createElementVNode("div", _hoisted_125, [
                (_unref(v$).authentication_method.$model === _unref(AuthenMethodTypes).EMAIL)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(['form-control', 'show-info-field']),
                      name: "email",
                      title: _unref(editNormalData).email?.trim()
                    }, _toDisplayString(_unref(editNormalData).email || 'sample@yelloop.jp'), 9, _hoisted_126))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(['form-control', 'show-info-field']),
                      name: "phone",
                      title: _unref(fullPhoneNumber)?.trim()
                    }, _toDisplayString(_unref(fullPhoneNumber) || _unref(translate)(`phoneExample`)), 9, _hoisted_127)),
                _createElementVNode("div", {
                  class: _normalizeClass(['col-lg-12 col-form-label fs-7 while-spaces', { 'text-danger': _unref(v$).authentication_method.$model === _unref(AuthenMethodTypes).SMS }])
                }, _toDisplayString(_unref(v$).authentication_method.$model !== _unref(AuthenMethodTypes).EMAIL ? _unref(translate)('showRegisteredPhoneMessage') : _unref(translate)('showRegisteredEmailMessage')), 3),
                (_unref(v$).authentication_method.$model !== _unref(AuthenMethodTypes).EMAIL)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                      (_unref(v$).authentication_method.$model !== _unref(AuthenMethodTypes).EMAIL)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "button-test shadow button-router-link",
                            disabled: 
                    _unref(v$).phone_number_1.$error ||
                    _unref(v$).phone_number_2.$error ||
                    _unref(v$).phone_number_3.$error ||
                    !_unref(v$).phone_number_1.$model ||
                    !_unref(v$).phone_number_2.$model ||
                    !_unref(v$).phone_number_3.$model ||
                    _unref(showCountTime) ||
                    submittingButton.value
                  ,
                            onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_unref(sendTestPhoneNumber) && _unref(sendTestPhoneNumber)(...args)))
                          }, _toDisplayString(_unref(translate)('testSend')), 9, _hoisted_129))
                        : _createCommentVNode("", true),
                      (_unref(showCountTime))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_130, _toDisplayString(_unref(timeLeft)) + "秒後に再送可能です ", 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("h3", _hoisted_131, _toDisplayString(_unref(translate)('SD40SocialLinking')), 1),
        _createElementVNode("div", _hoisted_132, [
          _createElementVNode("div", _hoisted_133, [
            _createVNode(LineLoginButton, {
              class: "sns-integration-button",
              enabled: false,
              text: "integrate"
            }),
            _createVNode(ToggleSwitch, {
              "on-text": _unref(translate)('SD40Linked'),
              "off-text": _unref(translate)('SD40NotLinked'),
              checked: _unref(editNormalData).line_connected,
              onStateChange: onSnsLinkingSwitchStateChange(_unref(SNS_SITE).SNS_LINE),
              snsName: _unref(SNS_SITE).SNS_LINE
            }, null, 8, ["on-text", "off-text", "checked", "onStateChange", "snsName"])
          ]),
          _createElementVNode("div", _hoisted_134, [
            _createVNode(GoogleLoginButton, {
              class: "sns-integration-button",
              enabled: false,
              text: "integrate",
              theme: "light"
            }),
            _createVNode(ToggleSwitch, {
              checked: _unref(editNormalData).google_connected,
              onStateChange: onSnsLinkingSwitchStateChange(_unref(SNS_SITE).SNS_GOOGLE),
              snsName: _unref(SNS_SITE).SNS_GOOGLE,
              "on-text": _unref(translate)('SD40Linked'),
              "off-text": _unref(translate)('SD40NotLinked')
            }, null, 8, ["checked", "onStateChange", "snsName", "on-text", "off-text"])
          ]),
          false
            ? (_openBlock(), _createElementBlock("div", _hoisted_135, [
                _createVNode(FacebookLoginButton, {
                  class: "sns-integration-button",
                  enabled: false,
                  text: "integrate"
                }),
                _createVNode(ToggleSwitch, {
                  "on-text": _unref(translate)('SD40Linked'),
                  "off-text": _unref(translate)('SD40NotLinked'),
                  checked: _unref(editNormalData).facebook_connected,
                  onStateChange: onSnsLinkingSwitchStateChange(_unref(SNS_SITE).SNS_FACEBOOK),
                  snsName: _unref(SNS_SITE).SNS_FACEBOOK
                }, null, 8, ["on-text", "off-text", "checked", "onStateChange", "snsName"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_136, [
          _createTextVNode(_toDisplayString(_unref(translate)('SD40withdrawalService')), 1),
          _createVNode(_component_router_link, {
            to: `/${_unref(route)?.path?.split('/')[1]}/cancel_yelloop_confirm`,
            class: "hover-link text-black"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(translate)('SD40reset')), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("div", _hoisted_137, [
          _createElementVNode("div", _hoisted_138, [
            _createVNode(Button, {
              title: _unref(translate)('CO40buttonTop'),
              type: 'secondary',
              onClick: backToLobby
            }, null, 8, ["title"])
          ]),
          _createElementVNode("div", _hoisted_139, [
            _createVNode(Button, {
              class: "button-submit",
              title: _unref(translate)('confirm'),
              type: 'secondary',
              onClick: onSubmit
            }, null, 8, ["title"])
          ])
        ])
      ])
    ], 32),
    _createVNode(ModalConfirmUpdate, {
      jobNameParent: jobNameParent.value,
      jobNameChild: jobNameChild.value,
      errorUpdate: errorUpdate.value,
      handleError: handleError,
      ref: (_value, _refs) => {
        _refs['modalUpdate'] = _value
        modalUpdate.value = _value
      }
    }, null, 8, ["jobNameParent", "jobNameChild", "errorUpdate"]),
    _createElementVNode("div", _hoisted_140, [
      _createElementVNode("div", _hoisted_141, [
        _createElementVNode("div", _hoisted_142, [
          _createElementVNode("div", _hoisted_143, [
            _createElementVNode("h5", _hoisted_144, _toDisplayString(_unref(translate)('SE45resetEmail')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: resetFormEmail
            })
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[30] || (_cache[30] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_145, [
              _createElementVNode("div", _hoisted_146, [
                _createElementVNode("label", _hoisted_147, _toDisplayString(_unref(translate)('email')), 1),
                _createElementVNode("div", _hoisted_148, [
                  _createVNode(Status)
                ]),
                _createElementVNode("div", _hoisted_149, [
                  _createElementVNode("div", _hoisted_150, [
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((email_v$.value.email.$model) = $event)),
                      class: _normalizeClass(['form-control', email_v$.value.email.$error || emailSame.value ? 'is-invalid' : '']),
                      placeholder: _unref(translate)('placeholder'),
                      onKeyup: changeEmail
                    }, null, 42, _hoisted_151), [
                      [
                        _vModelText,
                        email_v$.value.email.$model,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createVNode(InputErrorMessage, {
                      title: _unref(translate)('email'),
                      params: [_unref(MIN_LENGTH_EMAIL), _unref(MAX_LENGTH_EMAIL)],
                      validator: email_v$.value.email.$errors[0]?.$validator
                    }, null, 8, ["title", "params", "validator"]),
                    (emailSame.value && !email_v$.value.email.$error)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_152, _toDisplayString(_unref(getMessage)(emailSame.value)), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_153, [
                _createElementVNode("label", _hoisted_154, _toDisplayString(_unref(translate)('emailConfirm')), 1),
                _createElementVNode("div", _hoisted_155, [
                  _createVNode(Status)
                ]),
                _createElementVNode("div", _hoisted_156, [
                  _createElementVNode("div", _hoisted_157, [
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((email_v$.value.emailConfirm.$model) = $event)),
                      class: _normalizeClass(['form-control', email_v$.value.emailConfirm.$error ? 'is-invalid' : '']),
                      placeholder: _unref(translate)('SC52typeAgain')
                    }, null, 10, _hoisted_158), [
                      [
                        _vModelText,
                        email_v$.value.emailConfirm.$model,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createVNode(InputErrorMessage, {
                      title: _unref(translate)('emailConfirm'),
                      params: [_unref(MIN_LENGTH_EMAIL), _unref(MAX_LENGTH_EMAIL)],
                      validator: email_v$.value.emailConfirm.$errors[0]?.$validator
                    }, null, 8, ["title", "params", "validator"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_159, [
              _createElementVNode("div", _hoisted_160, [
                _createElementVNode("div", _hoisted_161, [
                  _createVNode(Button, {
                    title: _unref(translate)('cancel'),
                    type: 'secondary',
                    "data-bs-dismiss": "modal",
                    onClick: resetFormEmail
                  }, null, 8, ["title"])
                ]),
                _createElementVNode("div", _hoisted_162, [
                  _createVNode(Button, {
                    class: "button-submit",
                    title: _unref(translate)('SE40updateEmail'),
                    type: 'secondary',
                    onClick: submitConfirmEmail,
                    disabled: loadingConfirmMail.value,
                    loading: loadingConfirmMail.value
                  }, null, 8, ["title", "disabled", "loading"])
                ])
              ])
            ])
          ], 32)
        ])
      ])
    ]),
    _createVNode(EditEmailConfirm, {
      email: formDataEmail.value.email,
      modalConfirmEmail: modalConfirmEmail.value
    }, null, 8, ["email", "modalConfirmEmail"]),
    _createVNode(EditComplete, { resetFormEmail: resetFormEmail }),
    _createElementVNode("div", _hoisted_163, [
      _createElementVNode("div", _hoisted_164, [
        _createElementVNode("div", _hoisted_165, [
          _createElementVNode("div", _hoisted_166, [
            _createElementVNode("h5", _hoisted_167, _toDisplayString(_unref(translate)('SE47resetPassword')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: resetFormPassword
            })
          ]),
          _createElementVNode("div", _hoisted_168, [
            _createElementVNode("form", {
              onSubmit: _cache[34] || (_cache[34] = _withModifiers(() => {}, ["prevent"]))
            }, [
              (serverError.value)
                ? (_openBlock(), _createBlock(ErrorMessage, {
                    key: 0,
                    title: _unref(translate)('SD40updatePasswordError')
                  }, null, 8, ["title"]))
                : (validateNotChange.value)
                  ? (_openBlock(), _createBlock(ErrorMessage, {
                      key: 1,
                      title: _unref(translate)(serverErrorCode.value)
                    }, null, 8, ["title"]))
                  : (validateCurrentPassword.value)
                    ? (_openBlock(), _createBlock(ErrorMessage, {
                        key: 2,
                        title: _unref(getMessage)(serverErrorCode.value)
                      }, null, 8, ["title"]))
                    : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_169, _toDisplayString(_unref(translate)('SC52heading')), 1),
              _createElementVNode("div", _hoisted_170, [
                _createElementVNode("div", _hoisted_171, [
                  _createElementVNode("label", _hoisted_172, _toDisplayString(_unref(translate)('password')), 1),
                  _createElementVNode("div", _hoisted_173, [
                    _createVNode(Status)
                  ]),
                  _createElementVNode("div", _hoisted_174, [
                    _createElementVNode("div", _hoisted_175, [
                      _withDirectives(_createElementVNode("input", {
                        type: "password",
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_unref(password_v$).password.$model) = $event)),
                        class: _normalizeClass(['form-control', _unref(password_v$).password.$error ? 'is-invalid' : '']),
                        placeholder: _unref(translate)('placeholder')
                      }, null, 10, _hoisted_176), [
                        [
                          _vModelText,
                          _unref(password_v$).password.$model,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      _createVNode(InputErrorMessage, {
                        title: 'password',
                        params: [8, 128],
                        validator: _unref(password_v$).password.$errors[0]?.$validator
                      }, null, 8, ["validator"])
                    ]),
                    _createElementVNode("p", _hoisted_177, _toDisplayString(_unref(translate)('SC52notice')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_178, [
                  _createElementVNode("label", _hoisted_179, _toDisplayString(_unref(translate)('SE40passwordConfirm')), 1),
                  _createElementVNode("div", _hoisted_180, [
                    _createVNode(Status)
                  ]),
                  _createElementVNode("div", _hoisted_181, [
                    _createElementVNode("div", _hoisted_182, [
                      _withDirectives(_createElementVNode("input", {
                        type: "password",
                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_unref(password_v$).password_confirmation.$model) = $event)),
                        class: _normalizeClass(['form-control', _unref(password_v$).password_confirmation.$error ? 'is-invalid' : '']),
                        placeholder: _unref(translate)('SC52typeAgain')
                      }, null, 10, _hoisted_183), [
                        [
                          _vModelText,
                          _unref(password_v$).password_confirmation.$model,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      _createVNode(InputErrorMessage, {
                        title: _unref(translate)('SE40passwordConfirm'),
                        params: [8, 128],
                        validator: _unref(password_v$).password_confirmation.$errors[0]?.$validator
                      }, null, 8, ["title", "validator"])
                    ]),
                    _createElementVNode("p", _hoisted_184, _toDisplayString(_unref(translate)('SB20noticePassConfirm')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_185, [
                  _createElementVNode("label", _hoisted_186, _toDisplayString(_unref(translate)('currentPassword')), 1),
                  _createElementVNode("div", _hoisted_187, [
                    _createVNode(Status)
                  ]),
                  _createElementVNode("div", _hoisted_188, [
                    _createElementVNode("div", _hoisted_189, [
                      _withDirectives(_createElementVNode("input", {
                        type: "password",
                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_unref(password_v$).current_password.$model) = $event)),
                        class: _normalizeClass(['form-control', _unref(password_v$).current_password.$error ? 'is-invalid' : '']),
                        placeholder: _unref(translate)('placeholder')
                      }, null, 10, _hoisted_190), [
                        [
                          _vModelText,
                          _unref(password_v$).current_password.$model,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      _createVNode(InputErrorMessage, {
                        title: _unref(translate)('currentPassword'),
                        params: [8, 128],
                        validator: _unref(password_v$).current_password.$errors[0]?.$validator
                      }, null, 8, ["title", "validator"])
                    ]),
                    _createElementVNode("p", _hoisted_191, _toDisplayString(_unref(translate)('SD40noticeCurrentPass')), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_192, [
                _createElementVNode("div", _hoisted_193, [
                  _createElementVNode("div", _hoisted_194, [
                    _createVNode(Button, {
                      title: _unref(translate)('cancel'),
                      type: 'secondary',
                      "data-bs-dismiss": "modal",
                      onClick: resetFormPassword
                    }, null, 8, ["title"])
                  ]),
                  _createElementVNode("div", _hoisted_195, [
                    _createVNode(Button, {
                      class: "button-submit",
                      title: _unref(translate)('update'),
                      type: 'secondary',
                      onClick: submitPasswordConfirm,
                      loading: loadingConfirmPassword.value,
                      disabled: loadingConfirmPassword.value
                    }, null, 8, ["title", "loading", "disabled"])
                  ])
                ])
              ])
            ], 32)
          ])
        ])
      ])
    ]),
    _createVNode(EditCompletePassword, { resetForm: resetFormPassword }),
    _createVNode(SnsUnlinkConfirm, {
      ref: (_value, _refs) => {
        _refs['snsUnlinkConfirmDialog'] = _value
        snsUnlinkConfirmDialog.value = _value
      },
      onUnlinkConfirm: onUnlinkConfirm
    }, null, 512),
    _createVNode(SnsUnlinkComplete, {
      ref: (_value, _refs) => {
        _refs['snsUnlinkCompleteDialog'] = _value
        snsUnlinkCompleteDialog.value = _value
      }
    }, null, 512),
    _createVNode(Loading, { loading: snsGenerateLinkLoading.value }, null, 8, ["loading"])
  ], 64))
}
}

})